import React from 'react'

import useTranslation from '@/Hooks/UseTranslation'

import './PpcMethodNotice.scss'

const PpcMethodNotice = () => {
  const { t } = useTranslation()

  return (
    <aside className="ppc-method-notice" role="note" aria-label={t('LEAN_INDICATORS:PPCComparisonTitle')}>
      <div className="ppc-method-notice__heading">
        <i className="fas fa-info-circle" aria-hidden="true" />
        <div>
          <strong>{t('LEAN_INDICATORS:PPCComparisonTitle')}</strong>
          <p>{t('LEAN_INDICATORS:PPCComparisonDescription')}</p>
        </div>
      </div>

      <div className="ppc-method-notice__methods">
        <div>
          <span>{t('LEAN_INDICATORS:PPCLegacyName')}</span>
          <p>{t('LEAN_INDICATORS:PPCLegacyDefinition')}</p>
        </div>
        <div>
          <span>{t('LEAN_INDICATORS:PPCLeanName')}</span>
          <p>{t('LEAN_INDICATORS:PPCLeanDefinition')}</p>
        </div>
      </div>

      <div className="ppc-method-notice__footer">
        <small>{t('LEAN_INDICATORS:PPCNotComparable')}</small>
      </div>
    </aside>
  )
}

export default PpcMethodNotice
